<script setup lang="ts">
import { useI18n } from "vue-i18n";

defineProps({
    columns: {
        type: Array as () => { field: string; text: string }[],
        required: true,
    },
});

const { t } = useI18n();
</script>
<template>
    <DataTable :value="[Object(), Object()]" table-style="min-width: 78rem">
        <Column v-for="column in columns" :field="column.field" :header="t(column.text)" :key="column.field">
            <template #body>
                <Skeleton></Skeleton>
            </template>
        </Column>
    </DataTable>
</template>
